import { contribuyenteService } from "../../../_services/contribuyente.service";
import { dashboardConstants } from "../constants";

export const getContribuyentes = (data) => async (dispatch) => {
  dispatch(request());
  try {
    const response = await contribuyenteService.getContribuyentes(data);

    if (!Array.isArray(response)) {
      dispatch(failure(response));
    } else {
      dispatch(success(response));
    }

  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED,  payload: { contList: [] } };
  }
  function failure(error) {
    return { type: dashboardConstants.FETCH_ERROR, payload: error };
  }
  function success(list) {
    return { type: dashboardConstants.SET_CONT_LIST, payload: list };
  }
};


export const getContribuyente = (id) => async (dispatch) => {
  dispatch(request());
  try {
    const data = await contribuyenteService.getContribuyente(id);
    if (typeof data === "string") {
      dispatch(failure(data));
    } else {
      dispatch(success(data));
    }
  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(error) {
    return { type: dashboardConstants.FETCH_ERROR, payload: error };
  }
  function success(list) {
    return { type: dashboardConstants.SET_CONTRIBUYENTE, payload: list };
  }
};